import { orderBy } from 'lodash-es';

import { IDataTableSorting } from '../components/DataTable';

export const sortTableItems = <A>(
  sorting: IDataTableSorting,
  items: A[]
): A[] => orderBy(items, [sorting.property], [sorting.sortDirection]);
